import { Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import type * as Highcharts from 'highcharts';
// Side-effect import kept from the original fesm2015 build.
import 'highcharts';

@Component({
  selector: 'highcharts-chart',
  template: '',
  standalone: false
})
export class HighchartsChartComponent implements OnDestroy, OnChanges {
  @Input() Highcharts!: typeof Highcharts;
  @Input() constructorType!: string;
  @Input() callbackFunction!: Highcharts.ChartCallbackFunction;
  @Input() oneToOne!: boolean; // #20
  @Input() runOutsideAngular!: boolean; // #75
  @Input() options!: Highcharts.Options;
  @Input() update!: boolean;

  @Output() updateChange = new EventEmitter<boolean>(true);
  @Output() chartInstance = new EventEmitter<Highcharts.Chart>(); // #26

  private chart!: Highcharts.Chart | null;

  constructor(
    private el: ElementRef,
    private _zone: NgZone // #75
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const update = changes['update'] && changes['update'].currentValue;
    if (changes['options'] || update) {
      this.wrappedUpdateOrCreateChart();
      if (update) {
        this.updateChange.emit(false); // clear the flag after update
      }
    }
  }

  wrappedUpdateOrCreateChart(): void {
    if (this.runOutsideAngular) {
      this._zone.runOutsideAngular(() => {
        this.updateOrCreateChart();
      });
    } else {
      this.updateOrCreateChart();
    }
  }

  updateOrCreateChart(): void {
    if (this.chart && this.chart.update) {
      this.chart.update(this.options, true, this.oneToOne || false);
    } else {
      this.chart = (this.Highcharts as any)[this.constructorType || 'chart'](
        this.el.nativeElement,
        this.options,
        this.callbackFunction || null
      );

      // emit chart instance on init
      this.chartInstance.emit(this.chart as Highcharts.Chart);
    }
  }

  ngOnDestroy(): void { // #44
    if (this.chart) { // #56
      this.chart.destroy();
      this.chart = null;
    }
  }
}
